import { Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { Plugin, PluginKey } from "@tiptap/pm/state";
import { SectionHeadingNodeView } from "@/components/unified/SectionHeadingNodeView";

let idCounter = Date.now();
const nextId = () => `h${(idCounter++).toString(36)}`;

export const SectionNodeExtension = Node.create({
  addAttributes() {
    return {
      required: {
        default: false,
        parseHTML: (el) => el.dataset.required === "true",
        renderHTML: (attrs) => (attrs.required ? { "data-required": "true" } : {}),
      },
      sectionId: {
        default: null,
        parseHTML: (el) => el.dataset.sectionId,
        renderHTML: (attrs) =>
          attrs.sectionId ? { "data-section-id": attrs.sectionId as string } : {},
      },
    };
  },
  addNodeView() {
    return ReactNodeViewRenderer(SectionHeadingNodeView);
  },
  addProseMirrorPlugins() {
    return [
      new Plugin({
        appendTransaction: (_transactions, _oldState, newState) => {
          const tr = newState.tr;
          let modified = false;
          let pos = 0;
          for (let i = 0; i < newState.doc.childCount; i++) {
            const node = newState.doc.child(i);
            if (node.type.name === "section" && !node.attrs.sectionId) {
              tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                required: false,
                sectionId: nextId(),
              });
              modified = true;
            }
            pos += node.nodeSize;
          }
          return modified ? tr : null;
        },
        key: new PluginKey("sectionAutoId"),
      }),
    ];
  },
  content: "inline*",

  defining: true,

  group: "block",

  name: "section",

  parseHTML() {
    return [{ tag: "h2[data-section-node]" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["h2", { ...HTMLAttributes, "data-section-node": "" }, 0];
  },
});
